import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Button } from '@openng/optimus-ui/button';

@Component({
    selector: 'app-forbidden',
    imports: [Button],
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
        :host {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 80vh;
        }
        .forbidden-card {
            text-align: center;
            padding: 3rem 2rem;
            background: var(--stela-surface);
            border-radius: 12px;
            box-shadow: var(--stela-shadow-md);
            max-width: 480px;
            width: 100%;
        }
        .forbidden-card i.fa-lock {
            font-size: 3rem;
            color: var(--stela-danger);
            margin-bottom: 1rem;
        }
        .forbidden-card h2 {
            color: var(--stela-text-primary);
            margin-bottom: 0.5rem;
        }
        .forbidden-card p {
            color: var(--stela-text-secondary);
            margin-bottom: 1.5rem;
        }
    `],
    template: `
<div class="forbidden-card">
    <i class="fa fa-lock"></i>
    <h2>Acceso denegado</h2>
    <p>No tiene permisos para acceder a esta sección.</p>
    <a href="/#/dashboard/list">
        <p-button icon="fa fa-home" label="Volver al inicio"></p-button>
    </a>
</div>
    `
})
export class ForbiddenComponent {}
